import { NswContractStage, QldContractStage } from '@urbanx/agx-ui-components';
import { AgxButton } from '@urbanx/agx.ui-components2';
import { useSelectedContract } from 'hooks';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import ContractTerminateModal from './contract-terminate-modal/ContractTerminateModal';
import ContractWithdrawOfferModal from './contract-withdraw-offer-modal/ContractWithdrawOfferModal';

const TerminateContractAction = () => {
  const { contract, isTaskWorkflowEnabled } = useSelectedContract();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { contractId } = useParams();
  const isPendingNswOffer =
    contract?.contractStage === NswContractStage.PendingSolicitorExchange ||
    contract?.contractStage === NswContractStage.PendingAgentExchange;
  const isContractTerminated =
    contract?.contractStage === QldContractStage.Terminated ||
    contract?.contractStage === NswContractStage.Terminated;

  if (!isTaskWorkflowEnabled || contract?.contractStage === NswContractStage.Withdrawn) return null;

  return (
    <>
      <AgxButton
        id="btnTerminateContract"
        text={isPendingNswOffer ? 'Withdraw Offer' : 'Terminate Contract'}
        variant="naked"
        danger
        onClick={() => setShowConfirmation(true)}
        disabled={isContractTerminated}
      />
      {isPendingNswOffer && contractId ? (
        <ContractWithdrawOfferModal
          contractId={contractId}
          isOpen={showConfirmation}
          setIsOpen={setShowConfirmation}
        />
      ) : (
        <ContractTerminateModal isOpen={showConfirmation} setIsOpen={setShowConfirmation} />
      )}
    </>
  );
};

export default TerminateContractAction;
